export default __webpack_public_path__ + "2dc0f2fe075de8127d56ea247a8c24ad.png";